import { CaseAttachmentKey, LeadAttachmentKey, PersonnelAttachmentKey } from '@core/data-access';

export type AttachmentAttrKey = CaseAttachmentKey | PersonnelAttachmentKey | LeadAttachmentKey;
